import '@/styles/marketing.css';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="marketing-site min-h-screen overflow-x-hidden"
      style={{ fontFamily: 'var(--font-marketing-sans)' }}
    >
      <Outlet />
    </div>
  );
}
